import script from "./TopData.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopData.vue?vue&type=script&setup=true&lang=ts"

import "./TopData.vue?vue&type=style&index=0&id=79132384&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79132384"]])

export default __exports__